import React, { useState, useEffect, useRef } from 'react'
import Vendor from './types/Vendor'

export default function TipPicker({
	tip,
	setTip,
	vendors,
} :
{
	tip: number,
	setTip: (tip: number) => void,
	vendors: Vendor[],
}) {
	const selectedVendor = vendors.find((v) => v.selected)
	return (
		<div className='tip-picker'>
			<h3>Add a Tip for {selectedVendor ? selectedVendor.name : 'Vendor'}</h3>
			<div className='defaults'>
				<div className='presets'>
					{[100,200,500,1000].map((i) => (
						<div
							key={i}
							className="tip"
							onClick={() => setTip(tip + i)}
						>
							<h5>
								+{i/100}
							</h5>
						</div>
					))}
				</div>
				<div className="subtotal">
					<div>
						<input
							type="number"
							value={tip/100}
							min={0}
							onChange={(e) => setTip(parseFloat(e.target.value)*100)}
						/>
					</div>
					<h4 className='clear' onClick={() => setTip(0)}>
						×
					</h4>
				</div>
			</div>
		</div>
	)
}